"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _EventButton = _interopRequireDefault(require("../../atoms/EventButton/EventButton"));

var _Image = _interopRequireDefault(require("../../atoms/Image"));

require("./ItemElement.css");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ItemElement = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ItemElement, _React$Component);

  var _super = _createSuper(ItemElement);

  function ItemElement(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ItemElement);
    _this = _super.call(this, props);
    var content = _this.props.content;
    _this.state = {
      currentContent: _this.contentExceedsCharLimit() ? _this.getShortenedText() : content,
      buttonText: 'See More'
    };
    _this.expandOrContractLongText = _this.expandOrContractLongText.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ItemElement, [{
    key: "getShortenedText",
    value: function getShortenedText() {
      var _this$props = this.props,
          content = _this$props.content,
          charLimit = _this$props.charLimit;
      return content.substr(0, content.lastIndexOf(' ', charLimit)).concat('...');
    }
  }, {
    key: "contentExceedsCharLimit",
    value: function contentExceedsCharLimit() {
      var _this$props2 = this.props,
          content = _this$props2.content,
          charLimit = _this$props2.charLimit;
      return !(!content || content.length <= charLimit);
    }
  }, {
    key: "expandOrContractLongText",
    value: function expandOrContractLongText() {
      var content = this.props.content;
      var buttonText = this.state.buttonText;

      if (buttonText === 'See More') {
        this.setState({
          currentContent: content,
          buttonText: 'See Less'
        });
      }

      if (buttonText === 'See Less') {
        this.setState({
          currentContent: this.getShortenedText(),
          buttonText: 'See More'
        });
      }
    }
  }, {
    key: "renderEventButton",
    value: function renderEventButton() {
      var fluid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var floated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var _this$props3 = this.props,
          event = _this$props3.event,
          buttonSize = _this$props3.buttonSize,
          buttonBasic = _this$props3.buttonBasic,
          buttonColor = _this$props3.buttonColor;
      var buttonText = this.state.buttonText;

      if (event) {
        return /*#__PURE__*/_react["default"].createElement(_EventButton["default"], {
          className: "itemelement-more-button",
          event: event,
          color: buttonColor,
          fluid: fluid,
          floated: floated,
          primary: true,
          onClick: this.expandOrContractLongText,
          basic: buttonBasic,
          size: buttonSize
        }, buttonText);
      }

      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
        className: "itemelement-more-button",
        color: buttonColor,
        fluid: fluid,
        primary: true,
        onClick: this.expandOrContractLongText,
        basic: buttonBasic,
        size: buttonSize
      }, buttonText);
    }
  }, {
    key: "renderCard",
    value: function renderCard() {
      var _this$props4 = this.props,
          imageCircular = _this$props4.imageCircular,
          imageSize = _this$props4.imageSize,
          itemCenterContent = _this$props4.itemCenterContent,
          link = _this$props4.link,
          linkAs = _this$props4.linkAs,
          header = _this$props4.header,
          headerIcon = _this$props4.headerIcon,
          image = _this$props4.image,
          subheader = _this$props4.subheader,
          cardInlinePhoto = _this$props4.cardInlinePhoto;
      var asLink = linkAs === 'header' && link;
      var currentContent = this.state.currentContent;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card, {
        fluid: true
      }, !cardInlinePhoto && image && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        src: image,
        fluid: true
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Content, null, cardInlinePhoto && image && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        className: "itemelement-card-image",
        floated: cardInlinePhoto,
        size: imageSize,
        circular: imageCircular,
        src: image
      }), header && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Header, {
        className: "itemelement-card-header",
        as: asLink ? 'a' : '',
        href: asLink ? link : '',
        textAlign: itemCenterContent ? 'center' : 'left'
      }, header, headerIcon), subheader && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Meta, {
        className: "itemelement-card-subheader",
        textAlign: itemCenterContent ? 'center' : 'left'
      }, subheader), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Description, {
        textAlign: itemCenterContent ? 'center' : 'left'
      }, currentContent))), this.contentExceedsCharLimit() && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Card.Content, {
        textAlign: itemCenterContent ? 'center' : 'left',
        extra: true
      }, this.renderEventButton(true)));
    }
  }, {
    key: "renderVerticalItem",
    value: function renderVerticalItem() {
      var _this$props5 = this.props,
          content = _this$props5.content,
          imageSize = _this$props5.imageSize,
          imageCircular = _this$props5.imageCircular,
          verticalItemAlign = _this$props5.verticalItemAlign,
          link = _this$props5.link,
          linkAs = _this$props5.linkAs,
          header = _this$props5.header,
          headerIcon = _this$props5.headerIcon,
          image = _this$props5.image,
          subheader = _this$props5.subheader;
      var currentContent = this.state.currentContent;
      return /*#__PURE__*/_react["default"].createElement("div", null, image && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        src: image,
        size: imageSize,
        circular: imageCircular,
        style: {
          margin: verticalItemAlign === 'center' ? '0 auto -1em auto' : '0'
        }
      }), header && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header, {
        icon: true,
        textAlign: verticalItemAlign
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header.Content, {
        className: "itemelement-vertical-header itemelement-vertical-header-".concat(verticalItemAlign),
        as: linkAs === 'header' ? 'a' : 'h2',
        href: linkAs === 'header' ? link : ''
      }, header, headerIcon), subheader && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Header.Subheader, {
        className: "itemelement-vertical-subheader"
      }, subheader)), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          textAlign: verticalItemAlign
        },
        className: "itemelement-vertical-content"
      }, content && currentContent, this.contentExceedsCharLimit() && /*#__PURE__*/_react["default"].createElement("div", null, this.renderEventButton(false))));
    }
  }, {
    key: "renderHorizontalItem",
    value: function renderHorizontalItem() {
      var _this$props6 = this.props,
          content = _this$props6.content,
          imageSize = _this$props6.imageSize,
          link = _this$props6.link,
          linkAs = _this$props6.linkAs,
          header = _this$props6.header,
          headerIcon = _this$props6.headerIcon,
          image = _this$props6.image,
          subheader = _this$props6.subheader,
          itemCenterContent = _this$props6.itemCenterContent,
          itemButtonFloat = _this$props6.itemButtonFloat;
      var currentContent = this.state.currentContent;
      return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Item, null, image && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Item.Image, {
        size: imageSize,
        src: image
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Item.Content, {
        verticalAlign: itemCenterContent ? 'middle' : 'top'
      }, header && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Item.Header, {
        className: "itemelement-horizontal-header",
        as: linkAs === 'header' && link ? 'a' : '',
        href: linkAs === 'header' ? link : ''
      }, header, headerIcon), subheader && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Item.Meta, null, subheader), content && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Item.Description, null, currentContent), this.contentExceedsCharLimit() && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Item.Extra, null, this.renderEventButton(false, itemButtonFloat))));
    }
  }, {
    key: "render",
    value: function render() {
      var as = this.props.as;
      if (as === 'verticalItem') return this.renderVerticalItem();
      if (as === 'horizontalItem') return this.renderHorizontalItem();
      if (as === 'card') return this.renderCard();
      return /*#__PURE__*/_react["default"].createElement("div", null);
    }
  }]);
  return ItemElement;
}(_react["default"].Component);

exports["default"] = ItemElement;
ItemElement.propTypes = {
  header: _propTypes["default"].string.isRequired,
  as: _propTypes["default"].oneOf(['verticalItem', 'horizontalItem', 'card']),
  buttonBasic: _propTypes["default"].bool,
  buttonColor: _propTypes["default"].string,
  buttonSize: _propTypes["default"].string,
  cardInlinePhoto: _propTypes["default"].oneOf(['left', false]),
  charLimit: _propTypes["default"].number,
  content: _propTypes["default"].string,
  headerIcon: _propTypes["default"].element,
  image: _propTypes["default"].string,
  imageCircular: _propTypes["default"].bool,
  imageSize: _propTypes["default"].string,
  itemButtonFloat: _propTypes["default"].oneOf(['left', 'right']),
  itemCenterContent: _propTypes["default"].bool,
  link: _propTypes["default"].string,
  linkAs: _propTypes["default"].oneOf(['header', 'none']),
  subheader: _propTypes["default"].string,
  verticalItemAlign: _propTypes["default"].oneOf(['left', 'right', 'center']),
  event: _propTypes["default"].shape({
    category: _propTypes["default"].string,
    action: _propTypes["default"].string,
    label: _propTypes["default"].string
  })
};
ItemElement.defaultProps = {
  as: 'horizontalItem',
  buttonColor: 'blue',
  buttonBasic: false,
  buttonSize: 'medium',
  cardInlinePhoto: false,
  charLimit: 150,
  content: '',
  headerIcon: null,
  image: '',
  imageCircular: false,
  imageSize: 'small',
  itemButtonFloat: 'left',
  itemCenterContent: false,
  link: '',
  linkAs: 'none',
  subheader: '',
  verticalItemAlign: 'center',
  event: {}
};
ItemElement.propOptions = {
  buttonColor: ['primary', 'secondary']
};